<div class="played-lottery-wrapper">

  @if (numbersShow.length >= 1 && !manual && !automatic) {
    <div class="numbers-overview">
      <span class="text">Número de décimos</span>
      <div class="label"><span>{{numbers.length}}</span></div>
    </div>
  }

  @if (numbersShow.length === 1 && !manual && automatic) {
    <div class="single-lottery">
      <div class="ticket" [ngStyle]="{'background-image': backgroundImage}" >
        <span class="numbers" [ngClass]="{'empty': image == ''}">{{numbersShow[0].number}}</span>
      </div>
      <button class="change-button" (click)="triggerChangeNumber()">Cambiar <img class="icon"
        src="../../../../../../assets/images/icons/play-detail/shuffle.svg">
      </button>
    </div>
  }

  @if (!manual && !automatic && numbersShow.length > 0) {
    <div class="numbers-list">
      @for (number of numbersShow; track number) {
        <div class="number-item">
          <img [src]="imageMult ? imageMult : './../../../../../assets/images/background/empty_ticket.svg'" class="number-img">
          <div class="number-label">
            <span class="number">Nº {{number.number}}</span>
            <span class="amount">x{{number.count}}</span>
          </div>
          @if (!pack) {
            <button class="delete-button" (click)="deleteNumber(number.number)"><img src="/assets/images/icons/grupos/miembros/delete.svg" alt="img"></button>
          }
        </div>
      }
    </div>
  }

  @if (manual && numbersShow.length > 0) {
    <div class="multiple-lottery">
      <div class="selected-count" (click)="toggleTicketsVisibility()">{{numbers.length}} décimos seleccionados
        <button class="visible-button">
          <img class="icon" src="../../../../../../assets/images/icons/down.svg" [ngClass]="{'rotate': ticketsVisible}">
        </button>
      </div>
      <div class="selected-tickets" [ngClass]="{'hidden': !ticketsVisible}">
        @for (number of numbersShow; track number) {
          <div class="selected-ticket" [ngStyle]="{'background-image': backgroundImage}">
            <span class="ticket-number" [ngClass]="{'ticket-empty': imageMult == ''}">{{number.number}}</span>
            <div class="counter-badge">{{number.count}}</div>
            <button class="delete-button" (click)="deleteNumber(number.number)">X</button>
          </div>
        }
      </div>
    </div>
  }

</div>